import { createSlice } from "@reduxjs/toolkit";
import { FetchOrderDetailList, FetchOrderList } from "./dashboardAction";

interface DashboardState {
  dashboard: any | null;
  loading: boolean;
  error: string | null;
  totalRecord: number;
  orderDetails: any | null;
  detailsTotalRecord: number;
  openOrderListModal: boolean;
  modalListData: any


}

const initialState: DashboardState = {
  dashboard: [],
  orderDetails: [],
  loading: false,
  error: null,
  totalRecord: 0,
  detailsTotalRecord: 0,
  openOrderListModal: false,
  modalListData: { data: [], headers: [] },
};

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    setOpenOrderListModal: (state, { payload }) => {
      state.openOrderListModal = true;
      state.modalListData = payload;
    },
    setCloseOrderListModal: (state) => {
      state.openOrderListModal = false;
      state.modalListData = [];
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(FetchOrderList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(FetchOrderList.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.dashboard = payload.data;
        state.totalRecord = payload?.totalRecord || 0;
      })
      .addCase(FetchOrderList.rejected, (state, { payload }) => {
        state.loading = false;
        state.error =
          (payload as { responseMessage?: string })?.responseMessage || "Failed to fetch dashboard details";
      })
      .addCase(FetchOrderDetailList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
    .addCase(FetchOrderDetailList.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.orderDetails = payload.data;
      state.detailsTotalRecord = payload?.totalRecord || 0;
    })
    .addCase(FetchOrderDetailList.rejected, (state, { payload }) => {
      state.loading = false;
      state.error =
        (payload as { responseMessage?: string })?.responseMessage || "Failed to fetch invoice status";
    });
},
});

export const { setOpenOrderListModal, setCloseOrderListModal } = dashboardSlice.actions;

export const dashboardReducer = dashboardSlice.reducer;
